import {createRouter, createWebHistory} from "vue-router";

const routes = [
    {
        path: "/",
        name: "main",
        redirect: '/home'
    },
    {
        path: "/home",
        name: "home",
        component: () => import("@/views/HomeView.vue"),
    },
/*    {
        path: '/error',
        name: 'error',
        component: () => import('@/views/utils/ErrorView.vue')
    },*/
    {
        path: "/:catchAll(.*)",
        redirect: '/home',
    }
];

// TODO: 07/03/2025 15:33 - router downtime

const router = createRouter({
    history: createWebHistory(),
    scrollBehavior() {
        return { left: 0, top: 0 };
    },
    routes,
});

export default router;